import { useMutation } from '@tanstack/react-query';
import { includeOrExcludeAllReserveProducts } from './apiIncludeOrExcludeAllReserveProducts';
import { ReserveActionValue } from '../../../../store/reserve/actions';
import { invalidateReserveReportSummary } from '../reserve-list/useReserveReportSummary';
import {
    invalidateReserveReportProducts,
    updateAcceptedStateOfProducts
} from '../reserve-list/useReserveReportProducts';
import { RESERVE_ACCEPT_ACTION_VALUE } from '../../constants';

export type ProductAcceptRejectOptions = {
    action: ReserveActionValue;
};

export const useProductAcceptRejectMutation = (reserveListId: string, productId: string) => {
    return useMutation<void, unknown, ProductAcceptRejectOptions>(
        (options: ProductAcceptRejectOptions) => {
            updateAcceptedStateOfProducts(reserveListId, options.action === RESERVE_ACCEPT_ACTION_VALUE, productId);
            return includeOrExcludeAllReserveProducts(reserveListId, productId, options.action);
        },
        {
            onSuccess: () => {
                invalidateReserveReportSummary(reserveListId).then();
                invalidateReserveReportProducts(reserveListId).then();
            },
            onError: () => {
                invalidateReserveReportProducts(reserveListId).then();
            }
        }
    );
};
